import { render, staticRenderFns } from "./ClientDepartments.vue?vue&type=template&id=1defd610&scoped=true&"
import script from "./ClientDepartments.vue?vue&type=script&lang=js&"
export * from "./ClientDepartments.vue?vue&type=script&lang=js&"
import style0 from "./ClientDepartments.vue?vue&type=style&index=0&id=1defd610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1defd610",
  null
  
)

export default component.exports